export enum PropertyHeaderButtonVariant {
    NO_PRICE = "no-price",
    BLUR = "blur",
    VISIBLE = "visible"
}

interface IGetPropertyHeaderButtonVariantParams {
    propertyPrice: number | null;
    shouldShowPrice: boolean;
    shouldHidePrices: boolean;
    propsVariant: PropertyHeaderButtonVariant.VISIBLE | PropertyHeaderButtonVariant.BLUR;
}

export const getPropertyHeaderButtonVariant = ({
    propertyPrice,
    shouldShowPrice,
    shouldHidePrices,
    propsVariant
}: IGetPropertyHeaderButtonVariantParams): PropertyHeaderButtonVariant => {
    const propertyHasNoPrice = !propertyPrice;
    const variant = shouldShowPrice ? PropertyHeaderButtonVariant.VISIBLE : propsVariant;

    // Incomplete user + no price - registration flow
    if (propertyHasNoPrice && shouldHidePrices) {
        return PropertyHeaderButtonVariant.BLUR;
    }

    // Complete user + no price - lead form
    if (propertyHasNoPrice) {
        return PropertyHeaderButtonVariant.NO_PRICE;
    }

    if (variant === PropertyHeaderButtonVariant.BLUR) {
        return PropertyHeaderButtonVariant.BLUR;
    }

    return PropertyHeaderButtonVariant.VISIBLE;
};
export enum PropertyHeaderButtonVariant {
    NO_PRICE = "no-price",
    BLUR = "blur",
    VISIBLE = "visible"
}

interface IGetPropertyHeaderButtonVariantParams {
    propertyPrice: number | null;
    shouldShowPrice: boolean;
    shouldHidePrices: boolean;
    propsVariant: PropertyHeaderButtonVariant.VISIBLE | PropertyHeaderButtonVariant.BLUR;
}

export const getPropertyHeaderButtonVariant = ({
    propertyPrice,
    shouldShowPrice,
    shouldHidePrices,
    propsVariant
}: IGetPropertyHeaderButtonVariantParams): PropertyHeaderButtonVariant => {
    const propertyHasNoPrice = !propertyPrice;
    const variant = shouldShowPrice ? PropertyHeaderButtonVariant.VISIBLE : propsVariant;

    // Incomplete user + no price - registration flow
    if (propertyHasNoPrice && shouldHidePrices) {
        return PropertyHeaderButtonVariant.BLUR;
    }

    // Complete user + no price - lead form
    if (propertyHasNoPrice) {
        return PropertyHeaderButtonVariant.NO_PRICE;
    }

    if (variant === PropertyHeaderButtonVariant.BLUR) {
        return PropertyHeaderButtonVariant.BLUR;
    }

    return PropertyHeaderButtonVariant.VISIBLE;
};
